import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo, getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cargarCatalogos_Otros, cargarCatalogosAsync, cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf,generarReporteEnExcel} from '../../funciones_globales/interaccionApiReportes';
import moment from 'moment';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';

const COD_BOTON_SALDOCONTABLE = '090301';
const COD_BOTON_EXCEL = '090302';

class FormCartera03  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaCorte: null,
            cliente_sel: null,
            vendedor_sel: null,
            zona_sel: null,
            opt_oficial_credito: [],
            oficial_credito_sel: null,
            tipoReporte: 'C',
            plazo:'30',
            tipoSaldo: 'CLI',
            isVisibleBotonSaldoContab: false,
            isVisibleBotonExcel:false
        };

        this.imprimir = this.imprimir.bind(this);
        this.imprimirExcel = this.imprimirExcel.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 2 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    componentDidMount(){
        let usuario = getItemDatosSesion('usuario');

        Promise.all([
            cargarCatalogos_Otros('CLI-OFICIALES'),
            cargarPermisoBoton(COD_BOTON_SALDOCONTABLE, usuario),
            cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
            this.props.generar_LogAuditoriaIngresoForm('0903')
        ])
        .then(([catalogoOficiales, configBotonSaldoContab,configBotonExcel ])=>{
            let fechaProceso = getFechaProcesoPorModulo('09');
            let isVisibleBotonSaldoContab = false;
            let isVisibleBotonExcel = false;

            if(configBotonSaldoContab.display==='block'){
                isVisibleBotonSaldoContab = true;
            }

            if(configBotonExcel.display==='block'){
                isVisibleBotonExcel = true;
            }
            this.setState({              
                fechaCorte: moment(fechaProceso, 'DD/MM/YYYY'),
                opt_oficial_credito: catalogoOficiales,
                isVisibleBotonSaldoContab,
                isVisibleBotonExcel
            });
        })
        .catch((error)=>{
            alert(error);
        }) 
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0903');
    }

    imprimir(){
        try{            
            if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaCorte))){
                alert('La fecha Corte es inválida.');
                return;
            }

            let reporte;
            let dataEnvio = {};
            if(this.state.tipoReporte==='V'){
                reporte = 61;
            }else if(this.state.tipoReporte==='C'){
                reporte = 144;
            }else if(this.state.tipoReporte==='Z'){
                reporte = 60;
            }else if(this.state.tipoReporte==='D'){
                reporte = 99;
            }

            let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)}`;

            dataEnvio.fechaCorte = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte);
            
            if (this.state.tipoReporte==='C')
            {
                dataEnvio.plazo = this.state.plazo;
            }

            if(this.state.zona_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param2=${this.state.zona_sel.value}`;
                }
                dataEnvio.zona = this.state.zona_sel.value;
            }

            if(this.state.oficial_credito_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param3=${this.state.oficial_credito_sel.value}`;
                }
                dataEnvio.oficial = this.state.oficial_credito_sel.value;
            }

            if(this.state.vendedor_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param4=${this.state.vendedor_sel.value}`;
                }
                dataEnvio.vendedor = this.state.vendedor_sel.value;
            }

            if(this.state.cliente_sel && this.state.tipoReporte!=='C'){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param5=${this.state.cliente_sel.value}`; 
                }
                dataEnvio.cliente = this.state.cliente_sel.value;
            }

            if (this.state.tipoReporte!=='C')
            {
            urlReporte+=`&param6=${this.state.tipoSaldo}`;
            }

            
                if(this.state.tipoReporte==='C'){
                    let config_request = {
                    method: 'POST',
                    url: '/edadcarteraclientes',
                    data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    visualizarReporteEnPdf(urlReporte);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
            }    
            else
            if(this.state.tipoReporte==='D'){
                let config_request = {
                    method: 'POST',
                    url: '/carteraclientes',
                    data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    visualizarReporteEnPdf(urlReporte);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
            }
            else{
                visualizarReporteEnPdf(urlReporte);
            }
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    imprimirExcel(){
        try{            
            if(!validarFechaMomentEnFormatoString(formatearFechaMoment_a_String(this.state.fechaCorte))){
                alert('La fecha Corte es inválida.');
                return;
            }

            let reporte;
            let dataEnvio = {};
            if(this.state.tipoReporte==='V'){
                reporte = 136;
            }else if(this.state.tipoReporte==='C'){
                reporte = 143;
            }else if(this.state.tipoReporte==='Z'){
                reporte = 135;
            }else if(this.state.tipoReporte==='D'){
                reporte = 137;
            }

            let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)}`;

            dataEnvio.fechaCorte = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte);

            
            if (this.state.tipoReporte==='C')
            {
                dataEnvio.plazo = this.state.plazo;
            }

            if(this.state.zona_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param2=${this.state.zona_sel.value}`;
                }
                dataEnvio.zona = this.state.zona_sel.value;
            }

            if(this.state.oficial_credito_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param3=${this.state.oficial_credito_sel.value}`;
                }

                dataEnvio.oficial = this.state.oficial_credito_sel.value;
            }

            if(this.state.vendedor_sel){
                if (this.state.tipoReporte!=='C')
                {
                urlReporte+=`&param4=${this.state.vendedor_sel.value}`;
                }
                
                dataEnvio.vendedor = this.state.vendedor_sel.value;
            }

            if(this.state.cliente_sel && this.state.tipoReporte!=='C'){
                urlReporte+=`&param5=${this.state.cliente_sel.value}`; 
                dataEnvio.cliente = this.state.cliente_sel.value;
            }

            if (this.state.tipoReporte!=='C')
                {
            urlReporte+=`&param6=${this.state.tipoSaldo}`;
                }

            if(this.state.tipoReporte==='C'){
                let config_request = {
                    method: 'POST',
                    url: '/edadcarteraclientes',
                    data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    generarReporteEnExcel(urlReporte);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
            }    
            else
            if(this.state.tipoReporte==='D'){
                let config_request = {
                    method: 'POST',
                    url: '/carteraclientes',
                    data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{
                    this.props.cambiar_VisualizacionLoading(false);                    
                    generarReporteEnExcel(urlReporte);
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
            }
            else{
                generarReporteEnExcel(urlReporte);
            }
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('09');

        this.setState({            
            fechaCorte: moment(fechaProceso, 'DD/MM/YYYY'),            
            cliente_sel: null,
            vendedor_sel: null,
            zona_sel: null,
            oficial_credito_sel: null,
            tipoSaldo: 'CLI',
            tipoReporte: 'C',
            plazo:'30'

        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Cartera por Edades</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo de Reporte: </LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                            <div>                                
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="tipoReporte" value="C" checked={this.state.tipoReporte==="C"} onChange={this.handleInputChange} /> Por Cliente
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="tipoReporte" value="Z" checked={this.state.tipoReporte==="Z"} onChange={this.handleInputChange} /> Por Zona
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="tipoReporte" value="V" checked={this.state.tipoReporte==="V"} onChange={this.handleInputChange} /> Por Vendedor
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="tipoReporte" value="D" checked={this.state.tipoReporte==="D"} onChange={this.handleInputChange} /> Por Días Vencidos
                                </LabelForm>
                            </div>
                        </ContainerCol>
                    </Row>                   

                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Corte:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaCorte} func_onChange={(fecha)=>{this.setState({fechaCorte: fecha});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Zona:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.zona_sel} func_loadOptions={this.getOptions_Ciudad} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({zona_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Oficial de Crédito:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelect options={ this.state.opt_oficial_credito } value={this.state.oficial_credito_sel} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({oficial_credito_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Vendedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({vendedor_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({cliente_sel: value})}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo de Saldo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <div>
                                <LabelRadio className='radio-inline'><input type='radio' value='CLI' name='tipoSaldo' checked={this.state.tipoSaldo==='CLI'}
                                    onChange={this.handleInputChange}/> Saldo Cliente</LabelRadio>
                                {this.state.isVisibleBotonSaldoContab?
                                    <LabelRadio className='radio-inline'><input type='radio' value='CON' name='tipoSaldo' checked={this.state.tipoSaldo==='CON'}
                                        onChange={this.handleInputChange}/> Saldo Contable</LabelRadio>
                                :null}
                            </div>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Plazo Cartera Mayor a: </LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                            <div>                                
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="plazo" value="30" checked={this.state.plazo==="30"} onChange={this.handleInputChange} /> 30 Dias
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="plazo" value="45" checked={this.state.plazo==="45"} onChange={this.handleInputChange} /> 45 Dias
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="plazo" value="60" checked={this.state.plazo==="60"} onChange={this.handleInputChange} /> 60 Dias
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="plazo" value="90" checked={this.state.plazo==="90"} onChange={this.handleInputChange} /> 90 Dias
                                </LabelForm>
                            </div>
                        </ContainerCol>
                    </Row>    

                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>  
                            { this.state.isVisibleBotonExcel?
                                 <button type='button' className='btn btn-success btn-sm' onClick={this.imprimirExcel}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir EXCEL</button>  
                                :
                                null
                            }                     
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir PDF</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormCartera03);